/*
 * @Author: Dong
 * @Date: 2022-05-06 13:26:20
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-05-26 18:29:06
 */
import React from 'react';
import BusinessSyncBack from './BusinessSyncBack';
import SequenceSync from './SequenceSync';
import LogRecord from './LogRecord';
import Minio from './Minio';

import styles from './index.less';

const SyncBack = () => {
  return (
    <div className={styles.container}>
      <BusinessSyncBack />
      <Minio />
      <SequenceSync />
      <LogRecord />
    </div>
  );
};

export default SyncBack;
